import './Loader.css'

export default function Loader({ mini = false }: { mini?: boolean }) {
  return <div className={`loader${mini ? ' mini' : ''}`} />
}
